import { render } from "./HeaderSect.vue?vue&type=template&id=4214df4c&ts=true"
import script from "./HeaderSect.vue?vue&type=script&lang=ts"
export * from "./HeaderSect.vue?vue&type=script&lang=ts"

import "./HeaderSect.vue?vue&type=style&index=0&id=4214df4c&lang=scss"

import exportComponent from "/Users/damodar/Documents/PROGRAMMING/STUDING/everypay/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__